var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_888883",
    clipPath: "url(#clip0_5563_14683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.8975 1.1435C25.6751 0.962797 25.3822 0.893715 25.1026 0.956029L0.7276 6.58103C0.298606 6.67964 -0.00408909 7.06337 4.17661e-05 7.50353V39.3786C0.000217547 39.8411 0.337805 40.2345 0.795012 40.3048L25.17 44.0549C25.6818 44.1335 26.1604 43.7825 26.2391 43.2708C26.2463 43.2238 26.25 43.1762 26.25 43.1287V1.87853C26.2509 1.59262 26.121 1.32201 25.8975 1.1435Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.0626 40.3164H25.3125C24.7948 40.3164 24.375 39.8966 24.375 39.3788C24.375 38.8611 24.7948 38.4413 25.3125 38.4413H43.1251V6.56638H25.3125C24.7948 6.56638 24.375 6.14661 24.375 5.62885C24.375 5.11108 24.7948 4.69141 25.3125 4.69141H44.0625C44.5803 4.69141 45 5.11117 45 5.62894V39.3789C45 39.8967 44.5804 40.3164 44.0626 40.3164Z",
    fill: "#1565C0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9375 30.9417C15.5198 30.9413 15.1528 30.6644 15.0375 30.2629L12.1875 20.2916L9.33745 30.2629C9.13161 30.7605 8.56138 30.997 8.06374 30.7911C7.8245 30.6922 7.63448 30.5022 7.53552 30.2629L3.78558 17.1379C3.6286 16.6445 3.90142 16.1174 4.39484 15.9604C4.88825 15.8034 5.41542 16.0762 5.57239 16.5696C5.57793 16.587 5.58294 16.6046 5.58751 16.6223L8.43745 26.5916L11.2875 16.6204C11.4933 16.1229 12.0636 15.8864 12.5612 16.0922C12.8004 16.1912 12.9905 16.3812 13.0894 16.6204L15.9375 26.5917L18.7875 16.6224C18.9225 16.129 19.4319 15.8383 19.9253 15.9732C19.9323 15.9751 19.9393 15.9772 19.9463 15.9792C20.4438 16.1217 20.7316 16.6404 20.5894 17.1379L16.8394 30.2629C16.7239 30.6651 16.3559 30.942 15.9375 30.9417Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.3126 12.1915H25.3125C24.7948 12.1915 24.375 11.7717 24.375 11.2539C24.375 10.7362 24.7948 10.3164 25.3125 10.3164H40.3126C40.8303 10.3164 41.2501 10.7362 41.2501 11.2539C41.2501 11.7718 40.8303 12.1915 40.3126 12.1915Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.3126 17.8165H25.3125C24.7948 17.8165 24.375 17.3967 24.375 16.8789C24.375 16.3612 24.7948 15.9414 25.3125 15.9414H40.3126C40.8303 15.9414 41.2501 16.3612 41.2501 16.8789C41.2501 17.3967 40.8303 17.8165 40.3126 17.8165Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.3126 23.4415H25.3125C24.7948 23.4415 24.375 23.0217 24.375 22.5039C24.375 21.9862 24.7948 21.5664 25.3125 21.5664H40.3126C40.8303 21.5664 41.2501 21.9862 41.2501 22.5039C41.2501 23.0218 40.8303 23.4415 40.3126 23.4415Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.3126 29.0665H25.3125C24.7948 29.0665 24.375 28.6467 24.375 28.1289C24.375 27.6112 24.7948 27.1914 25.3125 27.1914H40.3126C40.8303 27.1914 41.2501 27.6112 41.2501 28.1289C41.2501 28.6468 40.8303 29.0665 40.3126 29.0665Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.3126 34.6915H25.3125C24.7948 34.6915 24.375 34.2717 24.375 33.7539C24.375 33.2362 24.7948 32.8164 25.3125 32.8164H40.3126C40.8303 32.8164 41.2501 33.2362 41.2501 33.7539C41.2501 34.2718 40.8303 34.6915 40.3126 34.6915Z",
    fill: "#1565C0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5563_14683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.d00300907b0e393b2794820f5f5cb033.svg";
export { ForwardRef as ReactComponent };